import { Dialog, DialogContent, Button, Box, Typography } from "@mui/material";

export default function ConfirmDelete({
  open,
  title,
  onConfirm,
  onClose,
}) {
  return (
      <Dialog
          open={open}
          onClose={onClose}
          fullWidth
            maxWidth="xs"
          sx={{
              "& .MuiDialog-container": {
                  alignItems: "flex-start", 
              },
          }}

      >

      <DialogContent sx={{ textAlign: "center", p: 4 }}>
        <Typography
          sx={{
            fontWeight: 600,
            color: "#01008B",
            mb: 3,
            fontSize: "16px",
          }}
        >
          {title}
        </Typography>

        <Box display="flex" justifyContent="center" gap={2}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#27A42D",
              px: 5,
              textTransform: "none",
                "&:hover": { backgroundColor: "#27A42D" },
            }}
            onClick={onConfirm}
          >
            Yes
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#E30404",
              px: 5,
              textTransform: "none",
              "&:hover": { backgroundColor: "#E30404" },
            }}
            onClick={onClose}
          >
            No
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
